import RequestActionHelper from '@kakadu-dev/base-frontend-helpers/helpers/Redux/RequestActionHelper'
import { DISCOUNT_CARD_ACTIONS } from './actionTypes'

const ACTIONS = {
	...DISCOUNT_CARD_ACTIONS,
}

export default RequestActionHelper.createReducerActions(Object.values(ACTIONS))
